// extracted by mini-css-extract-plugin
export default {"trianglecategory":"TriangleClip-module__trianglecategory"};